// @flow
import deepEqual from 'react-fast-compare';
import { EMPTY_SEARCH_LOCATION } from 'utils/constants';

export const makeSavedSearchLocation = (searchLocation: SearchLocation) =>
  deepEqual(searchLocation, EMPTY_SEARCH_LOCATION)
    ? { ...searchLocation, hasGeo: false }
    : { ...searchLocation, hasGeo: true };

export const filterToIndex = (t: ListingType) => {
  switch (t) {
    case 'VOLOP':
      return 'ACTIONS'; // rename?
    case 'GRAD_PROGRAM':
      throw new Error('Grad programs do not support saved searches');
    default:
      return 'MAIN';
  }
};
